import Controller from '../abstracts/Controller';
import 'scss-templates/t-sizeguide.scss';
import 'scss-templates/t-service-page.scss';
import _ from 'lodash';
import {isMobile, MobileBreakpoint} from '../utils/MobileUtils';

export default class SizeGuideController extends Controller {
  static get COMPONENTS() {
    return [
      'SizeTableSwitcherComponent',
      'DropdownComponent'
    ];
  }

  get SELECTORS() {
    return {
      cell: '[data-cell]'
    }
  }

  get CLASSES() {
    return {
      cellOnHover: 'hovered',
      activeCell: 'active'
    }
  }

  updateCellWidth() {
    const cells = $(this.SELECTORS.cell);
    if (isMobile(MobileBreakpoint.Max1023)) {
      cells.each((index, cell) => {
        cell.setAttribute('width', '45');
      });
    } else {
      cells.each((index, cell) => {
        cell.setAttribute('width', '74');
      });
    }
  }

  addOnHoverClassToSiblings(elem) {
    elem.classList.add(this.CLASSES.cellOnHover);
    if (elem.previousElementSibling) {
      this.addOnHoverClassToSiblings(elem.previousElementSibling);
    }
  }

  removeOnHoverClassToSiblings(elem) {
    elem.classList.remove(this.CLASSES.cellOnHover);
    if (elem.previousElementSibling) {
      this.removeOnHoverClassToSiblings(elem.previousElementSibling);
    }
  }

  addOnHoverClassToParents(elem, index) {
    elem.children[index].classList.add(this.CLASSES.cellOnHover);
    if (elem.previousElementSibling) {
      this.addOnHoverClassToParents(elem.previousElementSibling, index);
    }
  }

  removeOnHoverClassToParents(elem, index) {
    elem.children[index].classList.remove(this.CLASSES.cellOnHover);
    if (elem.previousElementSibling) {
      this.removeOnHoverClassToParents(elem.previousElementSibling, index);
    }
  }

  bindEvents() {
    const cells = $(this.SELECTORS.cell);
    cells.each((index, cell) => {
      cell.addEventListener('mouseenter', () => {
        cell.classList.add(this.CLASSES.activeCell);
        if (cell.previousElementSibling) {
          this.addOnHoverClassToSiblings(cell.previousElementSibling);
          if (cell.parentElement.previousElementSibling) this.addOnHoverClassToParents(cell.parentElement.previousElementSibling, cell.cellIndex);
        }
      });
      cell.addEventListener('mouseleave', () => {
        cell.classList.remove(this.CLASSES.activeCell);
        if (cell.previousElementSibling) {
          this.removeOnHoverClassToSiblings(cell.previousElementSibling);
          if (cell.parentElement.previousElementSibling) this.removeOnHoverClassToParents(cell.parentElement.previousElementSibling, cell.cellIndex);
        }
      });
    });

    const debouncedFunction = _.debounce(() => this.updateCellWidth(), 300);
    window.addEventListener('resize', debouncedFunction);
  }

  init() {
    super.init();
    this.bindEvents();
    this.updateCellWidth();
  }
}
